import React from "react"

// Styles
import * as styles from "./FooterCTA.module.scss"

const FooterCTA = (props) => {

    return <div className={styles.FooterCTA}>
        {props.title &&
            <h3>{props.title}</h3>
        }

        {props.text &&
            <div className={styles.description}>{props.text}</div>
        }

        {props.link &&
            <a href={props.link.url}>{props.buttonText}</a>
        }
    </div>

}

export default FooterCTA